import CustomerService from "@/services/customer.service";
import { Module } from "vuex";
import { AccountPhoneType } from "@/struct/AccountPhoneStruct";
import type { CreatePaymentType } from "@/struct/PaymentStruct";
import type { RootState } from "@/store";

const customerService = new CustomerService();

export interface CustomerState {
  phonesList: AccountPhoneType[] | null;
}

const customerModule: Module<CustomerState, RootState> = {
  namespaced: true,
  state: () => ({
    phonesList: null,
  }),
  getters: {},
  mutations: {
    SET_PHONES_LIST(state, payload) {
      state.phonesList = payload;
    },
  },
  actions: {
    changeMainPhone({ dispatch }, phoneNumber: string) {
      return customerService
        .changeMainCustomer(phoneNumber)
        .then((res) => {
          if (!res.status) {
            console.error("Бэкенд вернул ошибку смены телефона");
            return false;
          }
          return dispatch("tariff/updateSubscriptionDetails", null, {
            root: true,
          }).then(() => {
            return true;
          });
        })
        .catch((error) => {
          console.error("error на одном из этапов Change Main Phone", error);
          return;
        });
    },

    getUserPhoneList({ commit }) {
      customerService
        .getChildAccounts()
        .then((res) => {
          if (res?.data?.status) {
            commit("SET_PHONES_LIST", res.data.response);
          } else {
            console.error("error get User Phones List");
          }
        })
        .catch((err) => {
          console.error("error get User Phones List", err);
        });
    },

    // Возвращаем промис: PaymentPage ждёт { REF } из dispatch, чтобы
    // сделать редирект на платёжный шлюз. Без return dispatch резолвится
    // undefined ещё до ответа сервера и редирект не срабатывает.
    toPaymentCart({ dispatch }, payload: CreatePaymentType) {
      return customerService
        .createPayment(payload)
        .then((res) => {
          if (res?.data?.response?.REF) {
            return { success: true, REF: res.data.response?.REF };
          } else {
            dispatch(
              "system/openModal",
              { presetKey: "base_error" },
              { root: true }
            );
          }
        })
        .catch(() => {
          dispatch(
            "system/openModal",
            { presetKey: "base_error" },
            { root: true }
          );
        });
    },
  },
};

export default customerModule;
